"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowHeadType = void 0;
var ArrowHeadType;
(function (ArrowHeadType) {
    ArrowHeadType["Arrow"] = "arrow";
    ArrowHeadType["ArrowClosed"] = "arrowclosed";
})(ArrowHeadType = exports.ArrowHeadType || (exports.ArrowHeadType = {}));
